import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorContactInformation`

export default defineMessages({
  vendorNameLabel: {
    id: `${scope}.vendorNameLabel`,
    defaultMessage: 'Vendor name',
  },
  addressLabel: {
    id: `${scope}.addressLabel`,
    defaultMessage: 'Address',
  },
  contactRepresentativeLabel: {
    id: `${scope}.contactRepresentativeLabel`,
    defaultMessage: 'Contact representative',
  },
  websiteLabel: {
    id: `${scope}.websiteLabel`,
    defaultMessage: 'Website',
  },
  placeholderTextLabel: {
    id: `${scope}.placeholderTextLabel`,
    defaultMessage: '--',
  },
  vendorIdLabel: {
    id: `${scope}.vendorIdLabel`,
    defaultMessage: 'Vendor ID',
  },
  phoneLabel: {
    id: `${scope}.phoneLabel`,
    defaultMessage: 'Phone',
  },
  faxLabel: {
    id: `${scope}.faxLabel`,
    defaultMessage: 'Fax',
  },
  phoneAlternativeLabel: {
    id: `${scope}.phoneAlternativeLabel`,
    defaultMessage: 'Phone (alternative)',
  },
  commentsLabel: {
    id: `${scope}.commentsLabel`,
    defaultMessage: 'Comments',
  },
  editVendorButtonLabel: {
    id: `${scope}.editVendorButtonLabel`,
    defaultMessage: 'Edit vendor',
  },
})
